var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.object && _vm.object.label && _vm.object.value)?_c('div',[_vm._v(" "+_vm._s(_vm.object.label)+" - "+_vm._s(_vm.object.value)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }